import { createReducer } from 'redux-act';
import * as actions from '#app/actions/goalItem';

interface GoalItemState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: GoalItemState = {
  modalVisible: false,
  form: {},
};

const setGoalItemModalVisible = (state: GoalItemState, bool: boolean): GoalItemState => ({
  ...state,
  modalVisible: bool,
});

const setGoalItemForm = (state: GoalItemState, form: Record<string, unknown>): GoalItemState => ({
  ...state,
  form: form,
  modalVisible: true,
});

const closeGoalItemForm = (state: GoalItemState): GoalItemState => ({
  ...state,
  form: {},
  modalVisible: false,
});

export default createReducer<GoalItemState>(
  {
    [actions.setGoalItemModalVisible as any]: setGoalItemModalVisible,
    [actions.setGoalItemForm as any]: setGoalItemForm,
    [actions.closeGoalItemForm as any]: closeGoalItemForm,
  },
  initialState
);
